export default __webpack_public_path__ + "static/media/Term_Deposit_Icon.8cc2980d.svg";